import React from "react";

const Chemical = () => {
  const posts = [
    {
      id: 1,
      title: "Tantalum(V) Chloride",
      image: "/img/TantalumV-chloride.jpg",
      excerpt:
        "Tantalum(V) chloride (TaCl₅) is a key reagent in producing electronic capacitors, coatings, and advanced materials. It’s also used as a precursor for tantalum metal and oxides.",
    },
    {
      id: 2,
      title: "Iron (III) Chloride",
      image: "/img/IronIII-Chloride.jpg",
      excerpt:
        "Iron(III) chloride (FeCl₃) is widely used in wastewater treatment, printed circuit board etching, and as a catalyst in organic synthesis.",
    },
    {
      id: 3,
      title: "Silicon Powder",
      image: "/img/Silicon-powder.jpg",
      excerpt:
        "High-purity silicon powder is essential in semiconductor manufacturing, solar cells, and metallurgy. Its particle size and purity directly affect electrical performance.",
    },
    {
      id: 4,
      title: "Lead (II) Bromide",
      image: "/img/Lead-II-Bromide-1.jpg",
      excerpt:
        "Lead(II) bromide (PbBr₂) is an inorganic compound used in radiation detection materials and as a precursor for lead halide perovskites in optoelectronic applications.",
    },
    {
      id: 5,
      title: "Copper(II) Chloride",
      image: "/img/CopperII-chloride.jpg",
      excerpt:
        "Copper(II) chloride (CuCl₂) serves as a catalyst in organic synthesis, pigment manufacturing, and textile dyeing. It also plays a role in etching and oxidation processes.",
    },
    {
      id: 6,
      title: "5-Fluorouracil",
      image: "/img/5-Fluorouracil.jpg",
      excerpt:
        "5-Fluorouracil (5-FU) is a chemotherapy medication used to treat various cancers. It inhibits DNA synthesis, preventing the growth of malignant cells.",
    },
    {
      id: 7,
      title: "Phosphorus Pentachloride",
      image: "/img/Phosphorus-pentachloride.jpg",
      excerpt:
        "Phosphorus pentachloride (PCl₅) is a powerful chlorinating agent used in organic synthesis and industrial chemistry for producing acid chlorides and pharmaceuticals.",
    },
    {
      id: 8,
      title: "Aminebromoiodolead(II)",
      image: "/img/lead.png",
      excerpt:
        "Aminebromoiodolead(II) is an inorganic compound used in advanced materials research and as a precursor in organolead chemistry. It exhibits interesting halide reactivity and is studied for potential applications in catalysis and synthesis.",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header Section */}
      <header className="bg-white shadow-sm py-10 text-center">
        <h1 className="text-3xl font-bold text-gray-900">
          Chemical Insights Blog
        </h1>
        <p className="text-gray-500 mt-2">
          Latest articles on compounds and materials
        </p>
      </header>

      {/* Blog Grid */}
      <main className="max-w-7xl mx-auto px-6 py-12 grid gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {posts.map((post) => (
          <div
            key={post.id}
            className="bg-white rounded-2xl shadow-sm hover:shadow-lg transition duration-300 overflow-hidden group"
          >
            <div className="relative overflow-hidden">
              <img
                src={post.image}
                alt={post.title}
                loading="lazy"
                className="w-full h-56 object-cover transition duration-300 filter grayscale group-hover:grayscale-0 group-hover:brightness-110"
              />
            </div>

            <div className="p-5">
              <h2 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-blue-600">
                {post.title}
              </h2>
              <p className="text-gray-600 text-sm">{post.excerpt}</p>
            </div>
          </div>
        ))}
      </main>
    </div>
  );
};

export default Chemical;
